import React from 'react';

const ErrorMessage = ({ error }) => {
    if (!error) return null;

    // Helper function to extract readable message from error
    const getReadableError = (error) => {
        // If error is already a string, return it
        if (typeof error === 'string') return error;

        // Handle API error response structure
        if (typeof error === 'object') {
            // Handle non_field_errors array
            if (error.non_field_errors && Array.isArray(error.non_field_errors)) {
                return error.non_field_errors[0];
            }

            // Handle detail field
            if (error.detail) {
                return error.detail;
            }

            // Handle field-specific errors
            if (Object.keys(error).length > 0) {
                const firstErrorKey = Object.keys(error)[0];
                const firstError = error[firstErrorKey];
                if (Array.isArray(firstError)) {
                    return firstError[0];
                }
                return String(firstError);
            }
        }

        return 'An unexpected error occurred. Please try again.';
    };

    // Get the readable error message string
    const errorMessage = getReadableError(error);

    return (
        <div className="rounded-md bg-red-50 p-4 mt-4">
            <div className="flex">
                <div className="flex-shrink-0">
                    <svg className="h-5 w-5 text-red-400" viewBox="0 0 20 20" fill="currentColor">
                        <path fillRule="evenodd" d="M10 18a8 8 0 100-16 8 8 0 000 16zM8.707 7.293a1 1 0 00-1.414 1.414L8.586 10l-1.293 1.293a1 1 0 101.414 1.414L10 11.414l1.293 1.293a1 1 0 001.414-1.414L11.414 10l1.293-1.293a1 1 0 00-1.414-1.414L10 8.586 8.707 7.293z" clipRule="evenodd" />
                    </svg>
                </div>
                <div className="ml-3">
                    <p className="text-sm font-medium text-red-800">
                        {errorMessage}
                    </p>
                </div>
            </div>
        </div>
    );
};

export default ErrorMessage;